import { MultiVideoCameraGrowIcon } from '@sparemin/blockhead';
import * as React from 'react';

import bem from 'utils/bem';
import PaidSubscriptionSuccessMessage from './PaidSubscriptionSuccessMessage';

const block = bem('pro-grow-success-message');

const ProGrowSuccessMessage: React.FC = () => (
  <PaidSubscriptionSuccessMessage
    icon={<MultiVideoCameraGrowIcon height="85px" width="100%" />}
    message={
      <div className={block('message')}>
        Welcome to Headliner
        <br /> Pro + Grow!
      </div>
    }
  />
);

export default ProGrowSuccessMessage;
